module.exports = __webpack_public_path__ + "static/img/40.8442a9c0.png";